import * as React from 'react';
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {NavLink} from "react-router";
import {ReactComponent as OrangeTrieLogo} from '../images/orange_trie_logo_appbar.svg';

interface LogoProps {
  width?: number;
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

export const OrangeTrieLogoButton: React.FC<LogoProps> = ({
  width = 88,
  onClick,
  className = '',
  style = {}
}) => {
  const logoHeight = width * 158 / 500;  // orange_trie_logo_appbar.svg viewBox is 186 26 300 158 (tight crop)

  return (
    <Button
      component={NavLink}
      to={"/"}
      onClick={() => window.location.reload()}
      sx={{
        p: 0.5,
        minWidth: 'auto',
        background: 'transparent',
        '&:hover': {
          background: 'transparent',
          transform: 'scale(1.02)'
        }
      }}
    >
      <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 0,
            transition: 'transform 0.2s ease',
            m: 1,
            ...style
          }}
          className={className}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 0.5,
            transition: 'transform 0.2s ease',
            ...style
          }}
          className={className}
        >
            <OrangeTrieLogo
              width={width}
              height={logoHeight}
              onClick={onClick}
              style={{cursor: onClick ? 'pointer' : undefined, display: 'block'}}
            />
          <Typography
            sx={{
              color: '#40E0D0',
              fontSize: 10,
              fontWeight: 600,
              lineHeight: 1,
              fontFamily: 'system-ui, -apple-system, sans-serif'
            }}
          >
            Beta
          </Typography>
        </Box>
        <Typography
            sx={{
              color: '#FFFFFF',
              fontSize: 14,
              fontWeight: 600,
              lineHeight: 1,
              fontFamily: 'system-ui, -apple-system, sans-serif'
            }}
        >
          Orange Trie
        </Typography>
      </Box>
    </Button>
  );
}